<template>
    <div class="" data-cy="container_survey_question_item">
        <!-- Progress Header -->
        <div class="p-4">
            <div class="flex justify-between items-center">
                <p class="text-14 text-a-gray-5E5E66 font-medium">{{ lbl.golden_question.question.header }}</p>
                <p class="text-14 text-a-gray-5E5E66 font-medium">{{ currentStep }} {{ lbl.golden_question.question.from }} {{ totalSteps }}</p>
            </div>

        </div>
        <div class="flex gap-px">
            <div
                v-for="n in totalSteps"
                :key="n"
                :class="['h-1 flex-1', n <= currentStep ? 'bg-blue-600' : 'bg-gray-200']"
            ></div>
        </div>
        <!-- Illustration -->
        <div class="pb-4 sm-max:pb-2" v-html="getImage()"></div>

        <!-- Question Content -->
        <div class="sm-max:px-5 px-8 py-8 sm-max:py-5 rounded-t-3xl sm-max:mt-0 -mt-6 relative z-10 bg-white mb-[84px]">
            <h2 class="text-24 font-medium">{{ question.title }}</h2>
            <p class="text-base text-a-gray-5E5E66 pb-4 pt-2">{{ lbl.golden_question.question.description }}</p>

            <!-- Rating Buttons -->
            <div class="grid grid-cols-7 gap-2 items-center justify-items-center m-auto justify-around my-3 w-full">
                <button
                    v-for="n in question.inputs.length"
                    :key="n"
                    :data-cy="`btn_survey_question_rating_${n}`"
                    @click="selectRating(n)"
                    :class="[
                        'w-10 h-10 rounded-[14px] border flex items-center justify-center text-14 flex-shrink-0',
                        Number(selectedRating) === n
                            ? 'border-2 border-a-blue-0064ff bg-white text-a-gray-5E5E66'
                            : 'border border-a-gray-C8C8CC bg-white text-a-gray-5E5E66'
                    ]"
                >
                    {{ n }}
                </button>
            </div>

            <img class="w-full m-auto" src="../../../assets/icon/golden-question/img-divider.webp" alt="">

            <!-- Rating Labels -->
            <div class="flex justify-between text-14 text-a-gray-5E5E66 pt-3">
                <span>{{ lbl.golden_question.question.strongly_disagree }}</span>
                <span>{{ lbl.golden_question.question.strongly_agree }}</span>
            </div>
        </div>

        <!-- Action Buttons -->
        <div class="px-8 pb-8 pt-4 bg-white fixed bottom-0 w-full z-20 max-w-[500px]">
            <div class="flex gap-3">
                <button
                    class="flex-1 border-2 border-a-blue-0064ff text-a-blue-0064ff rounded-xl px-6 py-3 text-base font-medium min-h-12"
                    data-cy="btn_survey_question_back"
                    @click="$emit('prev')"
                >
                    {{ lbl.golden_question.question.back }}
                </button>
                <button
                    :data-cy="currentStep === totalSteps ? 'btn_survey_question_submit' : 'btn_survey_question_next'"
                    :class="[
                        'flex-1 rounded-xl px-6 py-3 text-base font-medium min-h-12 transition-colors',
                        selectedRating !== null
                            ? 'bg-a-blue-0064ff text-white'
                            : 'bg-a-gray-E3E3E5 text-a-gray-5E5E66'
                    ]"
                    :disabled="selectedRating === null"
                    @click="selectedRating !== null ? $emit('next') : null"
                >
                    {{ currentStep === totalSteps ? lbl.golden_question.question.result : lbl.golden_question.question.next }}
                </button>
            </div>
        </div>
    </div>
</template>
<script>
// import Util from '@/helper/Utility';
import LocaleMixin from '@/mixin/LocaleMixin';
export default {
    name: "QuestionItem",
    mixins: [LocaleMixin],
    props: {
        question: {
            type: Object,
            required: true
        },
        currentStep: {
            type: Number,
            default: 1
        },
        totalSteps: {
            type: Number,
            default: 8
        },
        selectedRating: {
            type: [Number, String],
            default: null
        }
    },
    methods: {
        selectRating(rating) {
            this.$emit('rate', rating);
        },
        getImage: function() {
            if (!this.question.html_question) return '';

            // สร้าง DOM element ชั่วคราวเพื่อ parse HTML
            const tempDiv = document.createElement('div');
            tempDiv.innerHTML = this.question.html_question;

            // ดึงเฉพาะ img tags
            const imgTags = tempDiv.querySelectorAll('img');
            let imageHtml = '';

            imgTags.forEach(img => {
                imageHtml += img.outerHTML;
            });

            return imageHtml;
        }
    }
}
</script>
<style scoped>
</style>
